import React from 'react';
import { FaArrowRight } from 'react-icons/fa';
import flutterIcon from '../assets/images/flutter.svg';
import platformIcon from '../assets/images/platefrom.svg';
import supportIcon from '../assets/images/supports.svg';
import appsIcon from '../assets/images/apps.svg';

const features = [
  {
    icon: flutterIcon,
    title: 'Flutter Expertise',
    description: 'We build fast, scalable, and beautiful apps with Flutter for iOS and Android.'
  },
  {
    icon: platformIcon,
    title: 'Cross-Platform Development',
    description: 'One codebase. Two platforms. Seamless experiences across iOS and Android.'
  },
  {
    icon: appsIcon,
    title: 'App Store Publishing',
    description: 'We manage the publishing process and help get your app live.'
  },
  {
    icon: supportIcon,
    title: 'Ongoing Support',
    description: 'Reliable maintenance and support to keep your app performing.'
  }
];

const FeatureCard = ({ feature }) => {
  return (
    <div className="why-feature-card">
      <div className="why-feature-icon">
        <span
          className="why-feature-icon-svg"
          aria-hidden="true"
          style={{ '--icon-url': `url("${feature.icon}")` }}
        />
      </div>
      
      <div>
        {feature.title && (
          <h3 className="why-feature-title">
            {feature.title}
          </h3>
        )}
        <p className="why-feature-description">
          {feature.description}
        </p>
      </div>
    </div>
  );
};

const WhyChooseUs = () => {
  return (
    <section className="why-choose-us-section" id="why-choose-us">
      <div className="glow-effect-right"></div>
      <div className="glow-effect-left"></div>
      <div className="why-choose-us-container">
        <div className="why-choose-us-header">
          <div className="why-choose-us-copy">
            <div className="why-choose-us-badge-wrap">
              <span className="about-badge">
                Why Choose Us
              </span>
            </div>

            <h2 className="why-choose-us-title">
              The Difference We Deliver
            </h2>
            
            <p className="why-choose-us-description">
              We deliver innovative digital solutions with cutting-edge technology, exceptional quality, and a client-first approach that helps businesses grow with confidence.
            </p>
          </div>
          
          <button 
            className="why-choose-us-action" 
            type="button"
            onClick={() => {
              window.location.hash = "#home";
              document.getElementById('home')?.scrollIntoView({ behavior: 'smooth' });
            }}
          >
            <FaArrowRight className="why-choose-us-action-icon" />
          </button>
        </div>

        <div className="why-feature-grid">
          {features.map((feature, index) => (
            <FeatureCard key={index} feature={feature} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
